import Api from 'libs/api/index';

class ContractTypesApi extends Api {
  constructor() {
    super('cv/contract_types/');
  }
}

export default ContractTypesApi;
